import React, { FC, useState } from 'react'
import {
  FlexContainer,
  useMediaQuery,
  Text2XL,
  TextBase,
  Button,
  elWFull,
  elFlex1,
  elHFull,
  elFlexAlignSelfCenter,
  elMt8,
  elMb7,
  elMt5,
  elMb5,
} from '@reapit/elements'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { ErrorBoundary } from '@reapitform/utils'
import { css, cx } from '@linaria/core'
import { TENANT_FORM_ROUTES } from '../routes'
import { useParams } from 'react-router-dom'
import StepNavigation from '../view/step-navigation'
import { DialogExitAgreement, BrandLogo, PageWrapper } from '@reapitform/common-ui'
import { useFormDocument } from '../view/layout/tenant-app-layout'

export const navigateToNextPage = (recipientId: string, stepsId: string, navigate: NavigateFunction) => (): void => {
  return navigate(`${TENANT_FORM_ROUTES.TENANT_BASED}/${recipientId}/steps/${stepsId}`)
}

export const Welcome: FC = () => {
  const navigate = useNavigate()
  const { isMobile } = useMediaQuery()
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const { recipientId = 'mok-id-forms' } = useParams<string>()
  const formDocumentData = useFormDocument()

  const handlerModalClose = (): void => {
    setIsModalOpen(false)
  }

  const handlerModalOpen = (): void => {
    setIsModalOpen(true)
  }

  const formDisplayName = formDocumentData?.formDisplayName || 'Agreement'
  const formDisplayPrepositionalPhrase = formDocumentData?.documentDisplayShortAddress
    ? `for ${formDocumentData?.documentDisplayShortAddress} `
    : ''

  return (
    <ErrorBoundary>
      <StepNavigation hideTitleOnMobile hideNav>
        <PageWrapper hasFullPage>
          <FlexContainer isFlexColumn className={cx(elHFull, elFlex1)}>
            <BrandLogo src={formDocumentData?.agentLogoUrl || '/pwa-152x152.png'} />
            <Text2XL hasMargin tag="h2" hasCenteredText hasBoldText>
              Welcome {formDocumentData?.recipientFirstName}!
            </Text2XL>
            <TextBase className={cx(elMt5, !isMobile && elMb5)} hasRegularText hasCenteredText>
              Your {formDisplayName} {formDisplayPrepositionalPhrase}is ready to sign. Review the details and sign the
              lease. Need changes? Simply tap “Request a change” on any screen.
            </TextBase>
            <Button
              onClick={navigateToNextPage(recipientId, String(formDocumentData?.nextStep || 1), navigate)}
              className={cx(elMt8, elMb7, elFlexAlignSelfCenter, isMobile && elWFull)}
              intent="primary"
              buttonSize="large"
            >
              Get Started
            </Button>
            <TextBase hasCenteredText intent="default">
              If this is not you, please{' '}
              <TextBase
                tag="span"
                intent="primary"
                className={cx(css`
                  cursor: pointer;
                `)}
                onClick={handlerModalOpen}
              >
                exit the agreement
              </TextBase>{' '}
              and contact your agent.
            </TextBase>
          </FlexContainer>
        </PageWrapper>
      </StepNavigation>
      <DialogExitAgreement {...{ isModalOpen, handlerModalClose }} />
    </ErrorBoundary>
  )
}
